<template>
<div>

    <el-dialog title="Cambiar estados" :ref="setStatusForm" :visible.sync="setStatusFormVisible" v-loading="loading">
        <el-form :model="resource" ref="setStatusForm" @submit.prevent="handleSetStatus" label-position="top" size="mini">
            <el-form-item label="Estado" label-width="140px" prop="status">
                <el-switch
                    style="display: block"
                    v-model="resource.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Abierto"
                    inactive-text="Cerrado"
                    active-value="OPE"
                    inactive-value="CLO">
                </el-switch>
            </el-form-item>
            <el-form-item label="Opciones" label-width="140px" prop="aspects">
                <el-checkbox-group v-model="resource.aspects">
                    <el-checkbox label="SA">Asignación de turnos</el-checkbox>
                    <el-checkbox label="PI">Permisos</el-checkbox>
                    <el-checkbox label="OA">Aprobación de horas</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="Fechas" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'},{validator: checkDateRange}]">
                <el-radio-group v-model="resource.range_selecion_type" size="mini">
                    <el-radio-button v-model="resource.range_selecion_type" label="all">Rango seleccionado</el-radio-button>
                    <el-radio-button v-model="resource.range_selecion_type" label="range">Otro rango</el-radio-button>
                </el-radio-group>
                <span v-if="resource.range_selecion_type == 'all'">{{resource.date_from}} - {{resource.date_to}}</span>
                <el-date-picker v-if="resource.range_selecion_type == 'range'"
                    v-model="resource.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    range-separator="-"
                    :picker-options="{firstDayOfWeek: 1}"
                    start-placeholder="Desde"
                    end-placeholder="Hasta"
                    :default-value="resource.date_range">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="setStatusFormVisible = false">Cancelar</el-button>
            <el-button type="primary" @click="handleSetStatus">Confirmar</el-button>
        </span>
    </el-dialog>

    <el-data-table 
        :resourceUrl="baseUrl"
        :showChecks="true"
        :filters="filters"
        ref="dataTable">

        <template slot="filtersDescription">
            <div v-if="filters.functional_area_id != null && filters.functional_area_id.length">Áreas: <strong>{{functional_area_name}}</strong></div>
            <div v-if="filters.date_from">Fechas: <strong>{{filters.date_from}} a {{filters.date_to}}</strong></div>
        </template>

        <template slot="filtersForm">
            <!-- <el-form-item label="Área" prop="functional_area_id">
                <el-select v-model="filters.functional_area_id" filterable placeholder="Seleccione">
                    <el-option
                        v-for="item in functional_areas"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="Fechas" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'}]">
                <el-date-picker
                    v-model="filters.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    align="right"
                    placeholder="Seleccione una fecha">
                </el-date-picker>                
            </el-form-item> -->

            <el-form-item label="Áreas" label-width="120px" prop="functional_area_id">
                <el-select multiple v-model="filters.functional_area_id" filterable placeholder="Seleccione">
                    <el-option label="Todas" :value="null"></el-option>
                    <el-option
                        v-for="item in functional_areas_for_user"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Fechas" prop="date_from" required :rules="[{required: true, message: 'Campo requerido'}]">
                <el-radio-group v-model="filters.date_selecion_type" size="mini">
                    <el-radio-button v-model="filters.date_selecion_type" label="week">Semana</el-radio-button>
                    <el-radio-button v-model="filters.date_selecion_type" label="month">Mes</el-radio-button>
                    <el-radio-button v-model="filters.date_selecion_type" label="range">Rango</el-radio-button>
                </el-radio-group>

                <el-week-picker v-if="filters.date_selecion_type == 'week'"
                    :value="Array.isArray(filters.date_week) ? filters.date_week[0] : null"
                    @input="weekPickerChange" 
                    type="week"
                    format="yyyy-MM-dd"
                    placeholder="Seleccione una semana">
                </el-week-picker>

                <el-date-picker v-if="filters.date_selecion_type == 'month'"
                    v-model="filters.date_month"
                    @input="monthPickerChange" 
                    type="month"
                    placeholder="Seleccione un mes">
                </el-date-picker>

                <el-date-picker v-if="filters.date_selecion_type == 'range'"
                    v-model="filters.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
                    start-placeholder="Desde"
                    end-placeholder="Hasta">
                </el-date-picker>                

            </el-form-item>

        </template>

        <template slot="selectedActions" slot-scope="scope">
            <el-button @click.prevent="handleSetStatusForm" :disabled="scope.checkedIds.length == 0 || !$auth.can(['shifts.close_period','shifts.open_period','overtime.close_period','overtime.open_period','permissions.close_period','permissions.open_period'])" icon="el-icon-time" size="mini">Cambiar estados</el-button>
            <!-- <a :disabled="downloadUrl == null" slot="top-buttons" class="btn btn-default btn-sm" :href="downloadUrl"><i class="fa fa-download"></i> Download</a> -->
        </template>

        <template slot="columns">
            <el-table-column
                type="selection"
                width="40">
            </el-table-column>
            <el-table-column
                width="90"
                align="center"
                prop="company_id_number"
                label="Cod. Área">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Área">
            </el-table-column>
            <el-table-column
                width="140"
                align="center"
                label="Asignación de Turnos">
                <template slot-scope="scope">
                    <el-tag :type="statusType(scope.row.status, 'SA')" size="mini">{{ status(scope.row.status, 'SA') }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                width="140"
                align="center"
                label="Permisos">
                <template slot-scope="scope">
                    <el-tag :type="statusType(scope.row.status, 'PI')" size="mini">{{ status(scope.row.status, 'PI') }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                width="140"
                align="center"
                label="Aprobación de Horas">
                <template slot-scope="scope">
                    <el-tag :type="statusType(scope.row.status, 'OA')" size="mini">{{ status(scope.row.status, 'OA') }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="Supervisores">
                <template slot-scope="scope">
                    <div v-for="user in scope.row.users" :key="user.id" style="line-height: 0.8em;">
                    {{ user.name }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="120"
                align="right"
                label="Cant. Empleados">
                <template slot-scope="scope">
                    <template v-if="scope.row.employee_assignments[0] != undefined">
                    {{ scope.row.employee_assignments[0].employees }}
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                width="120"
                align="right"
                label="Horas Extra No Aprobadas">
                <template slot-scope="scope">
                    <template v-if="scope.row.employee_assignments[0] != undefined">
                    {{ scope.row.employee_assignments[0].unauthorized_overtime }}
                    </template>
                </template>
            </el-table-column>
        </template>
    </el-data-table>

</div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { getOptionLabel } from '../../utils/lib';
    import el_data_table from '../el-data-table.vue';
    import el_week_picker from '../el-week-picker.vue';
    export default {
        data() {
            return {
                baseUrl: '/reports/functionalareastatus',
                functional_areas: [],
                filters: {
                    functional_area_id: null,
                    date_selecion_type: 'week',
                    date_range: null,
                    date_month: null,
                    date_week: null,
                    date_from: null,
                    date_to: null,
                },
                queryString: null,
                downloadUrl: null,
                setStatusFormVisible: false,
                setStatusForm: {},
                resource: {
                    functional_area_id: [],
                    status: 'CLO',
                    aspects: ['SA', 'PI', 'OA'],
                    range_selecion_type: 'all',
                    date_range: null,
                    date_from: null,
                    date_to: null
                },
                loading: false,
            }
        },
        computed: {
            ...mapGetters(["functional_areas_for_user"]),
            'functional_area_name': function () { return getOptionLabel(this.functional_areas_for_user, this.filters.functional_area_id) },
        },
		watch: {
			'$route': function (to) {
				this.fillFiltersForm(true);
            },
            'filters.date_selecion_type': function (to) {
                // console.log(to);
                switch(to){
                    case 'week':
                        this.weekPickerChange(this.filters.date_week);
                        break;
                    case 'month':
                        this.monthPickerChange();
                        break;
                    case 'range':
                        this.dateRangePickerChange();
                        break;
                }
            }
		},
        mounted: function () {
            this.fetchFunctionalAreasForUser();
            this.fillFiltersForm(true);
        },
        components: {
            'el-data-table': el_data_table,
            'el-week-picker': el_week_picker,
        },
        methods: {
            ...mapActions(["fetchFunctionalAreasForUser"]),
            fillFiltersForm: function () {
				_.each(this.filters, (value, key) => {
					// console.log(key);
					// console.log(this.$route.query[key]);
					if (this.$route.query[key] != undefined && this.$route.query[key] != null) {
                        if ((key == 'functional_area_id')  && !Array.isArray(this.$route.query[key])) {
                            this.filters[key] = [this.$route.query[key]];
                        } else {
                            this.filters[key] = this.$route.query[key];
                        }
					} else {
						// _.each(this.filters, (elem, idx) => {
						// 	if (elem.id == key && elem.mandatory)
						// 		this.filtersValid = false;
						// });
						this.filters[key] = null;
					}
                });
                if (this.filters.date_from != null && this.filters.date_to) {
                    this.filters.date_range = [
                        moment.parseZone(this.filters.date_from),
                        moment.parseZone(this.filters.date_to)
                    ];
                }
            },
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
            weekPickerChange(value) {
                // console.log(value);
                // console.log(this.filters.date_week);
                this.filters.date_week = value;

                this.filters.date_from = value[0];
                this.filters.date_to = value[1];
            },
            monthPickerChange() {
                let value = this.filters.date_month;
                // console.log(value);
                // console.log(this.filters.date_from);
                this.filters.date_from = moment(value).format('YYYY-MM-DD');
                this.filters.date_to = moment(value).endOf('month').format('YYYY-MM-DD');
            },
            status (status, aspect) {
                let open = 0;
                let closed = 0;
                for (let i in status) {
                    if (status[i].aspect == aspect) {
                        if (status[i].status == 'CLO') {
                            closed++;
                        } else {
                            open++;
                        }
                    }
                }
                if (closed == 0) {
                    return 'abierto';
                } else {
                    if (open == 0) {
                        return 'cerrado';
                    } else {
                        return 'abierto/cerrado';
                    }
                }
            },
            statusType (status, aspect) {
                let open = 0;
                let closed = 0;
                for (let i in status) {
                    if (status[i].aspect == aspect) {
                        if (status[i].status == 'CLO') {
                            closed++;
                        } else {
                            open++;
                        }
                    }
                }
                if (closed == 0) {
                    return 'success';
                } else {
                    if (open == 0) {
                        return 'danger';
                    } else {
                        return 'warning';
                    }
                }
            },
            handleSetStatusForm () {
                if (this.statusClosed) return;

                this.resource = {
                    status: 'CLO',
                    aspects: ['SA', 'PI', 'OA'],
                    range_selecion_type: 'all',
                    date_range: this.filters.date_range,
                    date_from: this.filters.date_from,
                    date_to: this.filters.date_to
                };
                this.setStatusFormVisible = true;
            },
            handleSetStatus () {
                // console.log(this.$refs['dataTable'].checkedIds);
                this.resource.functional_area_id = this.$refs['dataTable'].checkedIds;
                this.loading = true;
                axios.put('/api/functionalareas/statusbydate', this.resource).then((response) => {
                    this.$refs['dataTable'].clearSelection();
                    this.$refs['dataTable'].fetchItems();
                    this.loading = false;
                    this.setStatusFormVisible = false;
                    this.$notify({
                        title: 'Operación exitosa',
                        message: 'Los estados se cambiaron exitosamente',
                        type: 'success'
                    });
                }).catch((error) => {
                    this.loading = false;
                    this.$notify.error({
                        title: 'Error',
                        message: (error.response.data.message)
                    });
                });

            },
            checkDateRange(rule, value, callback) {
                let date_from = moment(value[0]).format('YYYY-MM-DD');
                let date_to = moment(value[1]).format('YYYY-MM-DD');
                if (date_from >= this.filters.date_from && date_to <= this.filters.date_to) {
                    callback();
                } else {
                    callback(new Error('Las fechas deben corresponder a la semana seleccionada.'));
                }
            },
            // setDownloadUrl: function () {
            //     // console.log(this.$route);
            //     this.queryString = $.param(this.$route.query);
            //     if (this.$route.query.date_from != undefined 
            //         && this.$route.query.date_to != undefined 
            //         && this.$route.query.date_from != null 
            //         && this.$route.query.date_to != null) {
            //         this.downloadUrl = '/api'+this.baseUrl+'/download?'+this.queryString+'&token='+localStorage.getItem('id_token');
            //     } else {
            //         this.downloadUrl = null;
            //     }
            // } 
        }
    }
</script>
